(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('c3WebApp')
        .constant('VERSION', "1.1.1")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
